function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16 8C9.925 8 5 12.925 5 19c0 2.005.536 3.882 1.471 5.5a1 1 0 11-1.731 1A12.945 12.945 0 013 19C3 11.82 8.82 6 16 6c2.82 0 5.429.897 7.559 2.422L22.16 9.886A10.949 10.949 0 0016 8zM26.047 14.514l1.684-1.122A12.949 12.949 0 0129 19c0 2.366-.633 4.588-1.74 6.5a1 1 0 11-1.731-1A10.945 10.945 0 0027 19c0-1.598-.34-3.116-.953-4.486zM26.742 8.466a.3.3 0 00-.447-.014l-5.835 6.114a.3.3 0 00-.012.4l.297.355a.3.3 0 00.396.056l7.035-4.684a.3.3 0 00.063-.442l-1.497-1.785z",
  fill: "currentColor"
})));